export default function GuidePage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-3.5rem)] bg-gray-100 p-4">
      <div className="w-full max-w-4xl bg-white p-6 sm:p-8 rounded-lg shadow-xl">
        <h1 className="text-3xl sm:text-4xl font-bold mb-8 text-center text-brand-dark">
          셀러헬퍼 사용 가이드
        </h1>
        <p className="text-center text-gray-700 mb-10 text-lg">
          셀러헬퍼의 주요 기능들을 영상으로 쉽고 빠르게 알아보세요!
        </p>

        <div className="space-y-12">
          {/* Video 1: General Usage */}
          <div className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
            <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-center text-brand-dark">
              셀러헬퍼 사용 방법 (1분 30초)
            </h2>
            <div className="aspect-video w-full">
              <iframe
                className="w-full h-full rounded-lg"
                src="https://www.youtube.com/embed/6SKQZWqnv2E"
                title="셀러헬퍼 사용 방법 (전체 개요)"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          {/* Video 2: Keep / Combine Shipping */}
          <div className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
            <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-center text-brand-dark">
              킵 / 합배 기능 사용 방법 (2분)
            </h2>
            <div className="aspect-video w-full">
              <iframe
                className="w-full h-full rounded-lg"
                src="https://www.youtube.com/embed/PtToFFHjr2M"
                title="셀러헬퍼 킵 / 합배 기능 사용 방법"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}